import { render, staticRenderFns } from "./DashboardTraining.vue?vue&type=template&id=66d70f1c&scoped=true"
import script from "./DashboardTraining.vue?vue&type=script&lang=js"
export * from "./DashboardTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d70f1c",
  null
  
)

export default component.exports